import React from 'react';
import DefaultButton from '../default-button/DefaultButton';
import { tabs } from '../../misc/constants';
import { userHasRole } from '../../misc/utils';
import { HasRole } from '../HasRole';


type DisciplinaryTabPropsType = {
  onTabChange: (tabId: string) => void,
  activeTab: string,
}

const DisciplinaryTab = ({ onTabChange, activeTab }: DisciplinaryTabPropsType) => {
  return (
    <div className='bg-white rounded-lg flex gap-1 w-fit p-2 mb-3'>
      {tabs.map(tab => (
        <HasRole roles={tab.roles}>
          <DefaultButton
            key={tab.id}
            Icon={tab.Icon}
            additionalStyle={`px-3 border-none text-sm gap-[5px] py-2 ${tab.id === activeTab ? 'text-white bg-blue-500' : 'text-black'}`}
            iconStyle={tab.id === activeTab ? 'text-white' : 'text-gray-400'}
            buttonText={tab.label}
            onClick={() => onTabChange(tab.id)}
          />
        </HasRole>
      ))}
    </div>
  );
};

export default DisciplinaryTab;
